import { useTranslation } from "react-i18next";

/**
 * This hook handles the validation of address form
 * @returns Object
 */
const useAddressValidation = (address, requiredAddressFields) => {
  const { t } = useTranslation();

  const validateAddress = async () => {
    const newErrors = {};
    if (address != null && address !== undefined) {
      requiredAddressFields.forEach((field) => {
        if (!address[field]?.trim()) {
          switch (field) {
            case 'addressName':
              newErrors[field] = t("FORM_CONTENT.FORM_ERROR.ADDRESS_NAME");
              break;
            case 'addressLine1':
              newErrors[field] = t("FORM_CONTENT.FORM_ERROR.ADDRESS");
              break;
            case 'cityTown':
              newErrors[field] = t("FORM_CONTENT.FORM_ERROR.TOWN/CITY");
              break;
            case 'country':
              newErrors[field] = t("FORM_CONTENT.FORM_ERROR.COUNTRY");
              break;
            case 'postCode':
              newErrors[field] = t("FORM_CONTENT.FORM_ERROR.POSTCODE_EMPTY");
              break;
            default:
              newErrors[field] = `This field is required`;
              break;
          }
        }
      });
    }
    return newErrors;
  }

  return { validateAddress }
};

export default useAddressValidation;